
import { WDFormInput } from './wd-form-input';

export class WDFormTime extends WDFormInput {
  constructor(cfg) {
    cfg.type = 'time';
    super(cfg);
  };
};

customElements.define('wd-form-time',WDFormTime);
